module.exports = __webpack_public_path__ + "static/media/Aquablation_Logo_RGB_Lockup_150.45de0902.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Aquablation_Logo_RGB_Lockup_150.png
// module id = 1376
// module chunks = 0